import React from 'react';

export function ChatMessagesLoading() {
    return (
        <div className="chat-messages-loading" aria-live="polite" aria-busy="true">
            <div className="spinner-border text-secondary" role="status">
                <span className="visually-hidden">Loading messages...</span>
            </div>
        </div>
    );
}

export function ChatMessagesEmpty({ imageSrc }) {
    return (
        <>
            <div className="chat_board_view d-flex flex-column align-items-center justify-content-center">
                <div className="text-center chat_notfound chat_notfound--compact">
                    <img src={imageSrc} alt="" width="100" height="100" />
                    <h1 className="text-center">Chat not found..!</h1>
                </div>
            </div>
            <div className="chat-not-found d-flex flex-column align-items-center justify-content-center">
                <div className="text-center chat_notfound chat_notfound--compact">
                    <img src={imageSrc} alt="" width="100" height="100" />
                    <h1 className="text-center">Chat not found..!</h1>
                </div>
            </div>
        </>
    );
}
